

























import { listFactory } from '@/main/pages';

import { showAlert } from '@/main/utils/notifications';
import { isMultipleWorkshopSelected, getSearchButtonLabel, handleMultiWorkshopFilter, validateDateFields, getCurrentLanguageId } from '@/main/utils/commonFunctions';

import { NAME } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	data() {
		return {
			parameters: 'null' as string,
			selectedWorkshops: [] as number[],
			fromDate: 'InvoiceDateFrom',
			toDate: 'InvoiceDateTo',
		};
	},
	computed: {
		isMultipleWorkshopSelected(): boolean {
			return isMultipleWorkshopSelected(this.OrganizationIds);
		},
		searchButtonLabelKey(): string {
			return getSearchButtonLabel(this.OrganizationIds);
		},
	},
	methods: {
		updateOrganizationId() {
			const result = {} as any;
			this.dropdownList.OrganizationId.forEach((o: any) => {
				result[o.Value] = o.Text;
			});
			if (this.filter.OrganizationIds == null) {
				this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
				return false;
			}
		},
		dateValidation() {
			if (this.InvoiceDateFrom && this.InvoiceDateTo) {
				const fromDate = new Date(this.InvoiceDateFrom);
				const toDate = new Date(this.InvoiceDateTo);
				const Startdate = fromDate.getDate();
				const endtdate = toDate.getDate();
				const startMonth = fromDate.getMonth();
				const endMonth = toDate.getMonth();
				const startYear = fromDate.getFullYear();
				const endYear = toDate.getFullYear();
				if (startMonth !== endMonth || startYear !== endYear) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DP_DATETOFROM_MONTH_VALIDATION') });
					this.InvoiceDateFrom = null;
					this.InvoiceDateTo = null;
					return false;
				}
				if (Startdate > endtdate) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('GREATER_DATE_VALIDATION') });
					this.InvoiceDateTo = null;
					return false;
				}
			} else {
				return false;
			}
			return true;
		},
		async filterClick() {
			if (!validateDateFields(this, this.fromDate, this.toDate)) {
				return;
			}
			await handleMultiWorkshopFilter(
				this,
				NAME,
				this.OrganizationIds,
				(columnsSeq) => ({
					OrganizationIds: this.OrganizationIds,
					InvoiceDateFrom: this.InvoiceDateFrom,
					InvoiceDateTo: this.InvoiceDateTo,
					ColumnSequence: columnsSeq.join(','),
					LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
				}),
			);
		},
		async exportFun() {
			try {
				if (this.filter.OrganizationIds == null || this.filter.OrganizationIds.length === 0) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
					return;
				}
				const columnsSeq = this.table.columns.filter(x => x.isVisible === true).map(x => x.columnName);
				this.startLoading();
				const urlParameters: string = this.GetParameters(this.OrganizationIds, this.InvoiceDateFrom, this.InvoiceDateTo);
				if (this.isMultipleWorkshopSelected) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
					});
				} else {
					await apiProvider.GetLabourSalesReport(urlParameters, columnsSeq);
				}
			} catch (error) {
				showAlert({
					message: this.LocalizeChyboveHlasky('LocalMsg'),
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: {
						type: 'error',
					},
				});
			} finally {
				this.endLoading();
			}
		},
		GetParameters(OrganizationIds : any, InvoiceDateFrom : any, InvoiceDateTo : any) {
			this.parameters = '';
			this.parameters = this.parameters.concat(`InvoiceDateFrom=${new Date(InvoiceDateFrom!).toISOString()}&InvoiceDateTo=${new Date(InvoiceDateTo).toISOString()}`);
			if (OrganizationIds.length > 0) {
				OrganizationIds.forEach((OrganizationId: any) => {
					this.parameters = this.parameters.concat(`&OrganizationIds=${OrganizationId}`);
				});
			}
			return this.parameters;
		},
	},
});
